<nav mat-tab-nav-bar class="shadow-md bg-white">
  <a mat-tab-link [routerLink]="['./', 'propx']" routerLinkActive #propx="routerLinkActive" [active]="propx.isActive">
    <span>Prop X</span>
  </a>
  <a mat-tab-link [routerLink]="['./', 'sandi']" routerLinkActive #sandi="routerLinkActive" [active]="sandi.isActive">
    <span>SANDi®</span>
  </a>
  <a mat-tab-link [routerLink]="['./', 'eog']" routerLinkActive #eog="routerLinkActive" [active]="eog.isActive">
    <span>EOG</span>
  </a>
  <a
    mat-tab-link
    [routerLink]="['./', 'solaris']"
    routerLinkActive
    #solaris="routerLinkActive"
    [active]="solaris.isActive"
  >
    <span>Solaris</span>
  </a>
  <a mat-tab-link [routerLink]="['./', 'cig']" routerLinkActive #cig="routerLinkActive" [active]="cig.isActive">
    <span>CIG</span>
  </a>
</nav>
<router-outlet></router-outlet>
